// extracted by mini-css-extract-plugin
module.exports = {"Container":"_3XDra","ImageContainer":"_2lMgO","Image":"_3g9nA","Wrapper":"ZDVrS"};